const getSupplierZip = ({ business, value }) => {
  if (value !== null && value !== undefined) {
    return value;
  }
  if (business && business['Company Address'] && business['Company Address']['Zip Code']) {
    return business['Company Address']['Zip Code'];
  }
  return null;
};

export default getSupplierZip;



// WEBPACK FOOTER //
// ./src/utils/print/getSupplierZip.js